/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_CustomizeInputs */

const en_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize`)
};

const de_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen`)
};

const fr_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnaliser`)
};

const es_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizar`)
};

const it_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza`)
};

const nl_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanpassen`)
};

const pl_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosuj`)
};

const fi_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mukauta`)
};

const da_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilpas`)
};

const sv_cookie_consent_customize = /** @type {(inputs: Cookie_Consent_CustomizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassa`)
};

/**
* | output |
* | --- |
* | "Customize" |
*
* @param {Cookie_Consent_CustomizeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_customize = /** @type {((inputs?: Cookie_Consent_CustomizeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_CustomizeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_customize(inputs)
	if (locale === "fr") return fr_cookie_consent_customize(inputs)
	if (locale === "es") return es_cookie_consent_customize(inputs)
	if (locale === "it") return it_cookie_consent_customize(inputs)
	if (locale === "nl") return nl_cookie_consent_customize(inputs)
	if (locale === "pl") return pl_cookie_consent_customize(inputs)
	if (locale === "fi") return fi_cookie_consent_customize(inputs)
	if (locale === "da") return da_cookie_consent_customize(inputs)
	if (locale === "sv") return sv_cookie_consent_customize(inputs)
	return en_cookie_consent_customize(inputs)
});